<div class="product-list-controls">
    <div class="product-list-controls__title">
        <h2>Filters</h2>
        <div class="product-list-controls__title-actions">
            <button
                type="button"
                class="product-list-controls__clear-btn"
                (click)="clearAllFilters()"
                [disabled]="!hasActiveFilters || loading"
            >
                Clear all
            </button>
            <button
                type="button"
                class="product-list-controls__collapse-btn"
                (click)="collapseFilters.emit()"
                title="Hide filters"
                aria-label="Hide filters"
            >
                <img src="assets/icons/chevron-left.svg" alt="" />
            </button>
        </div>
    </div>

    <ng-container *ngIf="!loading || (facetValues && facetValues.length > 0)">
        <div *ngIf="showSupplyTypeFilter" class="product-list-controls__facet">
            <span class="product-list-controls__facet-name">Supply Type</span>
            <vsf-supply-type-filter
                #supplyTypeFilter
                [loading]="loading"
                (filterChange)="onSupplyTypeFilterChange($event)"
            ></vsf-supply-type-filter>
        </div>

        <div
            *ngFor="let facet of filteredFacets; trackBy: trackById"
            class="product-list-controls__facet"
        >
            <span class="product-list-controls__facet-name">{{ facet.name }}</span>

            <div class="product-list-controls__facet-search">
                <input
                    type="text"
                    [(ngModel)]="searchTerm"
                    (input)="onSearchTermChange()"
                    placeholder="Search {{ facet.name | lowercase }}..."
                />
                <img src="assets/icons/search-icon.svg" alt="Search" />
            </div>

            <div *ngIf="facet.values.length === 0" class="product-list-controls__facet-empty">
                No results found
            </div>

            <div *ngIf="facet.values.length > 0" class="product-list-controls__facet-list">
                <ul>
                    <li
                        *ngFor="let value of facet.values | slice : 0 : (isFacetExpanded(facet.id) ? facet.values.length : 5); trackBy: trackById"
                        class="product-list-controls__facet-item group"
                        [class.active]="isActive(value.id)"
                        tabindex="0"
                        (click)="toggleFacetValueIdInRoute(value.id)"
                        (keydown.enter)="toggleFacetValueIdInRoute(value.id)"
                        (keydown.space)="$event.preventDefault(); toggleFacetValueIdInRoute(value.id)"
                    >
                        <label (click)="$event.stopPropagation()">
                            <input
                                type="checkbox"
                                [checked]="isActive(value.id)"
                                (change)="toggleFacetValueIdInRoute(value.id)"
                            />
                            <span class="product-list-controls__facet-item-text">{{ value.name }}</span>
                        </label>
                        <span class="product-list-controls__facet-item-count">
                            {{ value.count }}
                        </span>
                    </li>
                </ul>
            </div>

            <button
                *ngIf="facet.values.length > 5 || facet.values.length < facetTotalItems"
                class="product-list-controls__facet-show-more"
                (click)="onShowMoreClick(facet)"
            >
                <span>{{ isFacetExpanded(facet.id) ? 'Show less' : 'Show more' }}</span>
                <img src="assets/icons/chevron-down.svg" alt="" class="w-3 h-3 transition-transform" [class.rotate-180]="isFacetExpanded(facet.id)" />
            </button>
        </div>

        <div *ngIf="!supplierId && !isConsolidatedFeed" class="product-list-controls__facet">
            <div class="product-list-controls__facet-filter-heading-row">
                <span class="product-list-controls__facet-filter-label">Max MOV</span>
                <div class="product-list-controls__info-trigger group">
                    <img src="assets/icons/info-circle-outline.svg" alt="Info" class="product-list-controls__info-icon" />
                    <div class="product-list-controls__info-tooltip">
                        Show only offers with MOV up to this amount
                        <div class="product-list-controls__info-tooltip-caret"></div>
                    </div>
                </div>
            </div>
            <vsf-mov-filter
                #movFilter
                [filtersExpanded]="true"
                [loading]="loading"
                (filterChange)="onMovFilterChange($event)"
            ></vsf-mov-filter>
        </div>

        <div *ngIf="!supplierId && !isConsolidatedFeed" class="product-list-controls__facet">
            <div class="product-list-controls__facet-filter-heading-row">
                <span class="product-list-controls__facet-filter-label">Max ETA</span>
                <div class="product-list-controls__info-trigger group">
                    <img src="assets/icons/info-circle-outline.svg" alt="Info" class="product-list-controls__info-icon" />
                    <div class="product-list-controls__info-tooltip">
                        Show only offers delivered within this timeframe
                        <div class="product-list-controls__info-tooltip-caret"></div>
                    </div>
                </div>
            </div>
            <vsf-shipping-date-filter
                #shippingFilter
                [filtersExpanded]="true"
                [loading]="loading"
                (filterChange)="onShippingDateFilterChange($event)"
            ></vsf-shipping-date-filter>
        </div>
    </ng-container>

    <vsf-filter-skeleton
        *ngIf="loading"
        [showSearch]="true"
        [showCount]="true"
        [itemCount]="5"
    ></vsf-filter-skeleton>
</div>
